import { ca } from '@cian/analytics';

export const trackActionButtonClick = (label: string) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Chat',
    action: 'click_message_marketing',
    label,
  });
};
